import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.5 17H4c-.4 0-.8-.2-.9-.6-.2-.4-.1-.8.2-1.1L8.6 10 3.3 4.7c-.3-.3-.4-.7-.2-1.1.1-.4.5-.6.9-.6h18c.3 0 .5.1.7.3l6 6c.4.4.4 1 0 1.4l-2.8 2.8C25 13.2 24 13 23 13c-3.1 0-5.9 1.6-7.5 4M30 22c0-3.9-3.1-7-7-7s-7 3.1-7 7 3.1 7 7 7 7-3.1 7-7m-2 0c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5m-2-1h-2v-2c0-.6-.4-1-1-1s-1 .4-1 1v2h-2c-.6 0-1 .4-1 1s.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1v-2h2c.6 0 1-.4 1-1s-.4-1-1-1" }, null, -1)
  ]))]))
}
export default { render: render }